export const GET_ERRORS = "GET_ERRORS";
export const CLEAR_ERRORS = "CLEAR_ERRORS";
export const SET_CURRENT_USER = "SET_CURRENT_USER";
export const GET_PROFILE = "GET_PROFILE";
export const PROFILE_LOADING = "PROFILE_LOADING";
export const PROFILE_NOT_FOUND = "PROFILE_NOT_FOUND";
export const CLEAR_CURRENT_PROFILE = "CLEAR_CURRENT_PROFILE";
export const GET_PROFILES = "GET_PROFILES";
export const POST_LOADING = "POST_LOADING";
export const GET_POSTS = "GET_POSTS";
export const GET_POST = "GET_POST";
export const ADD_POST = "ADD_POST";
export const DELETE_POST = "DELETE_POST";
export const FILTER_BY_VALUE = "FILTER_BY_VALUE";
export const GET_BRUSSELS = "GET_BRUSSELS";
export const GET_BRUSSEL = "GET_BRUSSEL";
export const BRUSSEL_LOADING = "BRUSSEL_LOADING";
export const GET_LATEST_BRUSSELS = "GET_LATEST_BRUSSELS";
export const SET_LATEST_BRUSSEL_LOADING = "SET_LATEST_BRUSSEL_LOADING";

export const CITIES_POST_LOADING = "CITIES_POST_LOADING";
export const GET_CITIES_POSTS = "GET_CITIES_POSTS";
export const GET_CITIES_POST = "GET_CITIES_POST";
export const ADD_CITIES_POST = "ADD_CITIES_POST";

export const IMAGES_LOADING = "IMAGES_LOADING";
export const GET_IMAGES = "GET_IMAGES";
export const GET_IMAGE = "GET_IMAGE";
export const ADD_IMAGE = "ADD_IMAGE";

export const EXTRA_NOW_IMAGES_LOADING = "EXTRA_NOW_IMAGES_LOADING";
export const GET_EXTRA_NOW_IMAGES = "GET_EXTRA_NOW_IMAGES";
export const GET_EXTRA_NOW_IMAGE = "GET_EXTRA_NOW_IMAGE";
export const ADD_EXTRA_NOW_IMAGE = "ADD_EXTRA_NOW_IMAGE";
export const GET_SHORT_URL = "GET_SHORT_URL";